// https://github.com/nuxt-community/axios-module/issues/28
import { setClient } from '~/api/apiClient'
import { signParams } from '@yqz/base';

export default ({ app, store }) => {
  // 请求拦截
  app.$axios.onRequest((config) => {
    if (!config.params) {
      config.params = {}
    }

    if (config.method === 'get') {
      const { url, params } = config
      const keys = Object.keys(params)
      const subString = keys.reduce(
        (acc, key) => `${acc}&${key}=${encodeURIComponent(params[key])}`,
        ''
      )
      config.url = `${url}?${subString}`
      config.params = {}
    }
    // 添加统一参数
    Object.assign(config.params, { pl_user: 'pc_owner' }) 
    config.params = signParams(config.params, process.env.APP_SECRET)

  })

  setClient(app.$axios)
}
